type TGetUserFullLocation = (location?: {[key: string]: string}) => string

export const getUserFullLocation: TGetUserFullLocation = (location = {}) => {
  const {city, country, street, zip} = location
  return [city, country, street, zip].filter(item => item).join(', ')
}
